import * as bc from "bc-js";

import { useEffect } from "react";
import { useParams } from 'react-router';
import { LangueUtils } from "@oel/js-i18n";
import { en } from "./i18n/DetailCarteCredit.i18n.en";
import { fr } from "./i18n/DetailCarteCredit.i18n.fr";
import { GabaritNavigationUtil } from "../../../utils/gabarit-navigation/GabaritNavigationUtil";
import { IdPageEnum } from "../../../utils/gabarit-navigation/IdPageEnum";

export function DetailCarteCredit() {

    const params = useParams();
    const libelles = new LangueUtils(fr, en).obtenirLibelles();

    useEffect(() => {
        document.title = libelles.titreOnglet;
        GabaritNavigationUtil.afficherGabarit(IdPageEnum.DETAIL_CARTE_CREDIT_ADA);

        bc.changerContexte("ACCOUNT_Detail");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <detail-carte-credit id-contexte={params.idContexte} />
        </div>
    );
}
